import React, { MutableRefObject } from 'react'
import { addDays } from 'date-fns'
import Color from 'color'
import { connect } from 'react-redux'
import { Portal } from '@material-ui/core'
import Flex from 'typescript-styled-flex'
import { IStore } from '../../../reducers'
import {
  getFilteredRoomsWithEvents,
  IRoomWithEvents,
} from '../../../reducers/bookingCalendar/selectors/rooms'
import { getSortedSelectedColumns } from '../../../reducers/bookingCalendar/selectors/selectedColumns'
import FilterBar from '../FilterBar/FilterBar'
import { EventStatus } from '../../../models/Event'
import { getCalendarPreferences } from '../../../reducers/userObject/selectors/settings'
import Calendar from '../Calendar/Calendar'
import { getSummary } from '../../../reducers/bookingCalendar/selectors/summary'

export const PRINT_DAYS = 31

const PrintCalendar: React.FC<IPrintCalendarProps> = ({
  startDate,
  calendarRef,
  rooms,
  summary,
  selectedDays,
  size,
}) => {
  const finishDate = addDays(startDate, PRINT_DAYS - 1)

  return (
    <Portal>
      <Flex
        inline={true}
        column={true}
        ref={calendarRef}
        style={{
          border: 'none',
          display: 'none',
          position: 'relative',
          width: '1571px',
        }}
      >
        <div style={{ left: 0, position: 'absolute', top: 0 }}>
          <div className={'FilterBarContainer'}>
            <FilterBar
              size={size}
              startDate={startDate}
              finishDate={finishDate}
              isChanging={false}
              changeDate={null}
              print={true}
              wrapperStyle={{
                background: '#ffffff',
                paddingBottom: '15px',
                width: '1571px',
              }}
            />
          </div>
          <Calendar
            nonScrolling={true}
            summary={summary}
            rooms={rooms}
            errMessage={''}
            size={size}
            minDate={startDate}
            maxDate={finishDate}
            withToolbar={false}
            roomsAreLoading={false}
            eventsAreLoading={false}
            eventsFullRange={true}
            selectedDays={selectedDays}
            printCalendar={true}
          />
        </div>
      </Flex>
    </Portal>
  )
}

const mapStateToProps = (state: IStore) => {
  const preferences = getCalendarPreferences(state)

  return {
    colors: preferences.colors,
    rooms: getFilteredRoomsWithEvents(state),
    selectedDays: getSortedSelectedColumns(state),
    shape: preferences.shape,
    summary: getSummary(state),
  }
}

const PrintCalendarWithState = connect(mapStateToProps)(PrintCalendar)
export default PrintCalendarWithState

export interface IPrintCalendarProps {
  startDate?: Date
  rooms?: IRoomWithEvents[]
  size?: number
  shape?: 'square' | 'diamond'
  colors?: { [key in EventStatus]: Color }
  summary?: boolean
  calendarRef: MutableRefObject<HTMLDivElement>
  selectedDays?: Date[]
}
